import { E_ROUTR_RECOMMENDATION_MANAGEMENT } from './route.types';
export const recommendationManagement = [
    {
        name: 'recommendation-management',
        path: '/recommendation-management',
        redirect: {
            name: E_ROUTR_RECOMMENDATION_MANAGEMENT.HOME_PAGE_CONFIGURATION,
        },
        component: () => import(/* webpackChunkName: "recommendation" */ '../../views/recommendation-management/RecommendationManagement/RecommendationManagement.vue'),
        children: [
            {
                name: E_ROUTR_RECOMMENDATION_MANAGEMENT.HOME_PAGE_CONFIGURATION,
                path: 'home-page-configuration',
                component: () => import(/* webpackChunkName: "recommendation" */ '../../views/recommendation-management/HomePageConfiguration/HomePageConfiguration.vue'),
                props: true,
                redirect: {
                    name: E_ROUTR_RECOMMENDATION_MANAGEMENT.HOME_PAGE_CONFIGURATION_PRODUCTS,
                },
                children: [
                    {
                        name: E_ROUTR_RECOMMENDATION_MANAGEMENT.HOME_PAGE_CONFIGURATION_PRODUCTS,
                        path: 'products',
                        component: () => import(/* webpackChunkName: "recommendation" */ '../../views/recommendation-management/HomePageConfiguration/ProductConfiguration/ProductConfiguration.vue'),
                        props: true,
                        meta: {
                            breadcrumb: [
                                {
                                    text: 'backoffice.nav.operation_tool',
                                },
                                {
                                    text: 'backoffice.nav.recommendation_management',
                                },
                                {
                                    text: 'backoffice.nav.home_page_configuration',
                                },
                                {
                                    text: 'backoffice.homepage.products',
                                    active: true,
                                }
                            ],
                            permission: 'HomePageConfiguration',
                        },
                    },
                    {
                        name: E_ROUTR_RECOMMENDATION_MANAGEMENT.HOME_PAGE_CONFIGURATION_ADVERT,
                        path: 'advert',
                        component: () => import(/* webpackChunkName: "recommendation" */ '../../views/recommendation-management/HomePageConfiguration/AdvertConfiguration/AdvertConfiguration.vue'),
                        props: true,
                        meta: {
                            breadcrumb: [
                                {
                                    text: 'backoffice.nav.operation_tool',
                                },
                                {
                                    text: 'backoffice.nav.recommendation_management',
                                },
                                {
                                    text: 'backoffice.nav.home_page_configuration',
                                },
                                {
                                    text: 'backoffice.homepage.advert',
                                    active: true,
                                }
                            ],
                            permission: 'HomePageConfiguration',
                        },
                    }
                ],
            },
            {
                name: E_ROUTR_RECOMMENDATION_MANAGEMENT.DASHBOARD_EDITORSPICK_MANAGEMENT,
                path: '/dashboard-editorsPick-management',
                component: () => import(/* webpackChunkName: "recommendation" */ '../../views/functional-audit/Dashboard/Dashboard.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.operation_tool',
                        },
                        {
                            text: 'backoffice.nav.recommendation_management',
                        },
                        {
                            text: 'backoffice.nav.editer_pick_management',
                            active: true,
                        }
                    ],
                    permission: 'EditorsPickManagement',
                },
            }
        ],
    }
];
/**
 * 推荐管理 页面级子菜单
 * 注意这里的顺序需要和菜单顺序保持一致
 */
export const RecommendationManagementRoutePermissionTable = [
    /**
     * 首页配置
     */
    { name: `${E_ROUTR_RECOMMENDATION_MANAGEMENT.HOME_PAGE_CONFIGURATION}`, permission: 'HomePageConfiguration' },
    { name: `${E_ROUTR_RECOMMENDATION_MANAGEMENT.HOME_PAGE_CONFIGURATION_PRODUCTS}`, permission: 'HomePageConfiguration' },
    { name: `${E_ROUTR_RECOMMENDATION_MANAGEMENT.HOME_PAGE_CONFIGURATION_ADVERT}`, permission: 'HomePageConfiguration' },
    { name: `${E_ROUTR_RECOMMENDATION_MANAGEMENT.DASHBOARD_EDITORSPICK_MANAGEMENT}`, permission: 'EditorsPickManagement' }
];
